import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { defaultPurchaseFeed, PurchaseNotification } from '../data/purchaseNotifications';
type PurchaseNotificationsProps = {
  /** Supply real order data (or an approved external feed) in production. */
  feed?: PurchaseNotification[];
  /** Delay before the first notification, in milliseconds. */
  firstDelayMs?: number;
  /** Time between notifications after the first one, in milliseconds. */
  intervalMs?: number;
  /** How long each notification stays visible, in milliseconds. */
  visibleMs?: number;
};
export function PurchaseNotifications({
  feed = defaultPurchaseFeed,
  firstDelayMs = 5000,
  intervalMs = 15000,
  visibleMs = 4500
}: PurchaseNotificationsProps) {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (feed.length === 0) return;
    let hideTimeout: number | undefined;
    let cycle: number | undefined;
    const show = () => {
      setIsVisible(true);
      hideTimeout = window.setTimeout(() => {
        setIsVisible(false);
        setIndex(current => (current + 1) % feed.length);
      }, visibleMs);
    };

    /* First notification at 5s, then one every 15s after it (20s, 35s, ...). */
    const firstTimeout = window.setTimeout(() => {
      show();
      cycle = window.setInterval(show, intervalMs);
    }, firstDelayMs);
    return () => {
      window.clearTimeout(firstTimeout);
      window.clearTimeout(hideTimeout);
      if (cycle) window.clearInterval(cycle);
    };
  }, [feed.length, firstDelayMs, intervalMs, visibleMs]);
  if (feed.length === 0) return null;
  const current = feed[index];
  return <div className="pointer-events-none fixed inset-x-4 bottom-4 z-40 flex justify-center sm:inset-x-auto sm:bottom-6 sm:left-6 sm:justify-start" aria-live="polite" data-id="element-114" data-mp="yj4xoajj2w5w">
      <AnimatePresence data-id="element-115" data-mp="3j82df2rfe23k">
        {isVisible ? <motion.div key={current.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 6
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex w-full max-w-sm items-center gap-3 rounded-xl border border-char-line bg-char/95 px-3.5 py-2.5 shadow-lift backdrop-blur sm:max-w-xs" data-id="element-116" data-mp="3kr2czuyjhops">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-orange-tint text-orange" data-id="element-117" data-mp="3201et958tx7a">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-118" data-mp="36rt6jn04y8z0" />
            </span>
            <div className="min-w-0" data-id="element-119" data-mp="2s36j0y0cuawp">
              <p className="truncate text-[0.78rem] font-semibold text-ivory" data-id="element-120" data-mp="2s00w9pf77l45">
                {current.firstName} from {current.location}
              </p>
              <p className="truncate text-[0.7rem] text-ivory-dim" data-id="element-121" data-mp="2j2i6k7qm0ilx">
                Purchased Basketball Coach System™
              </p>
            </div>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}